import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=cc9047e8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=cc9047e8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9047e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc9047e8')) {
      api.createRecord('cc9047e8', component.options)
    } else {
      api.reload('cc9047e8', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=cc9047e8&scoped=true", function () {
      api.rerender('cc9047e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/terminal_scan/warning_report/detail/detail.vue"
export default component.exports